import { RootState } from '../index';


export const selectCurrentStore = (state: RootState) => (
  state.currentStore.currentStore
);

export const selectCurrentStoreLoading = (state: RootState) => (
    state.currentStore.loading
);

export const selectCurrentStoreSettingsSetup = (state: RootState) => (
  state.currentStore.settingsSetup
);

export const selectCurrentStoreSettingsSetupLoading = (state: RootState) => (
  state.currentStore.settingsSetupLoading
);

